export default __webpack_public_path__ + "static/media/about.20632c97.jpg";